//Name tab
tabApp.controller('tabNameController', ['$scope', '$http', function($scope, $http) {

    $scope.tName.getData = function() {

        $scope.global.hideTabError($scope.tName);
        $scope.global.loadedDealers = [];

        var name = $scope.tName.inputName;
        if (!validateInput('nameInput')) {
            $scope.tName.isError = true;
           // $scope.global.showTabError($scope.tName, 'No results found. Please try again');
            return;
        } else {
            $scope.tName.isError = false;
        }

        var zip = $scope.global.locationLabel;
        $scope.global.getDataForName(zip);

    }

}]);